import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.withPrefix('fpc-job', { allowSubId: true });
